import React from "react";
import styles from "./Loader.module.css";

interface LoaderProps {
	size?: "small" | "medium" | "large";
	color?: string;
	fullScreen?: boolean;
	text?: string;
	containerStyle?: React.CSSProperties;
}

export const Loader: React.FC<LoaderProps> = ({
	size = "small",
	color = "#9B7AFF",
	fullScreen = false,
	text,
	containerStyle,
}) => {
	const sizeMap = {
		small: 24,
		medium: 40,
		large: 64,
	};

	const loaderSize = sizeMap[size];

	const loaderStyle = {
		width: `${loaderSize}px`,
		height: `${loaderSize}px`,
		borderColor: `${color}20`,
		borderTopColor: color,
	};

	const containerClass = fullScreen
		? `${styles.loaderContainer} ${styles.fullScreen}`
		: styles.loaderContainer;

	return (
		<div className={containerClass} style={containerStyle}>
			<div className={styles.loader} style={loaderStyle}></div>
			{text && <div className={styles.loaderText}>{text}</div>}
		</div>
	);
};
